export const sliderItems = [
    {
      id: 1,
      img: "images/trackloader.jpeg",
      title: "RENTAL & SALE ITEMS",
      desc: "Look through our catalog:",
      bg: "FFFFFF",
      link: "/catalog",
    },
    {
      id: 2,
      img: "images/propanetank.JPG",
      title: "PROPANE EXCHANGE & REFILL",
      desc: "Find out more:",
      bg: "FFFFFF",
      link: "/propane",
    },
    {
      id: 3,
      img: "images/24hourkeys.png",
      title: "OUR UHAUL OFFERINGS",
      desc: "For more information:",
      bg: "FFFFFF",
      link: "/uhaul",
    },
];

export const sliderItemsUhaul = [
    {
      id: 1,
      img: "../images/uhaul1.jpeg",
    },
    {
      id: 2,
      img: "../images/uhaul2.jpeg",
    },
    {
      id: 3,
      img: "../images/uhual3.jpeg",
    },
];

export const row_one = [
    {
        id: 1,
        img: "../images/zlawnandgarden.png",
        title: "Lawn & Garden", 
        link: "/catalog/lawnandgarden",
    },
    {
        id: 2,
        img: "../images/zheavyequipment.jpeg",
        title: "Heavy Equipment", 
        link: "/catalog/heavyequipment",
    },
    {
        id: 3,
        img: "../images/zcement.jpeg",
        title: "Cement & Compaction", 
        link: "/catalog/cement",
    },
    {
        id: 4,
        img: "../images/zsaw.jpeg",
        title: "Saws", 
        link: "/catalog/saws",
    },
    {
        id: 5,
        img: "../images/zauger.jpeg",
        title: "Auger Equipment", 
        link: "/catalog/auger",
    },
    {
        id: 6,
        img: "../images/zladders.jpeg",
        title: "Scaffolding & Ladders", 
        link: "/catalog/scaffoldingandladders",
    },
    {
        id: 7,
        img: "../images/zpump.webp",
        title: "Washers & Pumps", 
        link: "/catalog/washersandpumps",
    },
    {
        id: 8,
        img: "../images/zgenerators.jpeg",
        title: "Generators", 
        link: "/catalog/generators"
    },
    {
        id: 9,
        img: "../images/zcompressor.jpeg",
        title: "Compressors", 
        link: "/catalog/compressors",
    },
    {
        id: 10,
        img: "../images/zfans.jpeg",
        title: "Fans", 
        link: "/catalog/fans",
    },
    {
        id: 11,
        img: "../images/zfloorcare.jpeg",
        title: "Indoor Care", 
        link: "/catalog/indoorcare",
    },
    {
        id: 12,
        img: "../images/5footround.webp",
        title: "Tables & Chairs", 
        link: "/catalog/tablesandchairs",
    },
    {
        id: 13,
        img: "../images/zhitch.jpeg",
        title: "Trailers & Accessories", 
        link: "/catalog/trailers",
    },
    {
        id: 14,
        img: "../images/zlgbox.jpeg",
        title: "Boxes & Moving Supplies", 
        link: "/catalog/moving",
    },
    {
        id: 15,
        img: "../images/zdolly.jpeg",
        title: "Misc. Items", 
        link: "/catalog/misc",
    },
];


export const popularProducts = [
    {
        id:1,
        img: "https://scontent-ort2-2.xx.fbcdn.net/v/t1.6435-9/65059227_10157249697559659_6121018288806821888_n.jpg?stp=dst-jpg_p180x540&_nc_cat=100&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=FORS1ogZiQQAX_tMQ7W&_nc_ht=scontent-ort2-2.xx&oh=00_AT_2fLvKDnzJkJZUgGzWrfRIPGnR7drcqSqgiZVs7tmOJw&oe=63092072",
        name: "Loader",
        link: "",
    },
    {
        id:2,
        img: "https://scontent-ort2-2.xx.fbcdn.net/v/t1.6435-9/49116984_10156846043834659_7738523029977694208_n.jpg?stp=dst-jpg_p180x540&_nc_cat=101&ccb=1-7&_nc_sid=8bfeb9&_nc_ohc=P_Fpsj-hZiUAX-V0YiR&_nc_ht=scontent-ort2-2.xx&oh=00_AT88RWzAsK9M_hkNhqoobnQvZPhwQ_6VbioEVdHlXaT_eA&oe=63090704",
        name: "Saw",
        link: "",
    },
    {
        id:3,
        img: "https://scontent-ort2-2.xx.fbcdn.net/v/t1.18169-9/25223_382553609658_603772_n.jpg?stp=dst-jpg_p526x296&_nc_cat=105&ccb=1-7&_nc_sid=9267fe&_nc_ohc=iS2DP2AnRYQAX_fU4Bn&_nc_ht=scontent-ort2-2.xx&oh=00_AT-A5qJVO937VfxVEhOOQUUrYIGiPXMWuwOy4UgEAJatzg&oe=6308A0E3",
        name: "Propane",
        link: "",
    },
    {
        id:4,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
    {
        id:5,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
    {
        id:6,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
    {
        id:7,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
    {
        id:8,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
    {
        id:9,
        img: "https://cdn.shopify.com/s/files/1/2143/3217/products/500_127d25fe-30c0-445c-875a-a2236412b02d_large.png?v=1624386906",
        name: "Shirt",
        link: "",
    },
];


export const trailerPhotos = [
    {
        id: 1,
        img: "../images/pontoon.JPG",
        name: "Pontoon Trailer",
        link: '/catalog/pontoontrailer',
    },
    {
        id: 2,
        img: "../images/blacktrl.JPG",
        name: "5x8 Enclosed Trailer",
        link: '/catalog/5x8enclosedtrailer',
    },
    {
        id: 3,
        img: "../images/bluetrl.JPG",
        name: "6x12 Enclosed Trailer",
        link: '/catalog/6x12enclosedtrailer',
    },
    {
        id: 4,
        img: "../images/hitch.JPG",
        name: "2 Inch Ball & Hitch",
        link: '/catalog/hitch',
    },
    {
        id: 5,
        img: "../images/adapter.JPG",
        name: "Trailer Light Adapter",
        link: '/catalog/lightadapter',
    },
]

export const washerandpumpPhotos = [
    {
        id: 1,
        img: "../images/threeinch.JPG",
        name: "Three Inch Gas Pump",
        link: '/catalog/threeinchgaspump',
    },
    {
        id: 2,
        img: "../images/twoinch.JPG",
        name: "Two Inch Gas Pump",
        link: '/catalog/twoinchgaspump',
    },
    {
        id: 3,
        img: "../images/electric.JPG",
        name: "Two Inch Submersible Electric Pump",
        link: '/catalog/twoinchelectricpump',
    },
    {
        id: 4,
        img: "../images/washer.JPG",
        name: "Pressure Washer",
        link: '/catalog/pressurewasher',
    },
    {
        id: 5,
        img: "../images/threeinchhose.JPG",
        name: "Three Inch Discharge Hose",
        link: '/catalog/threeinchhose',
    },
    {
        id: 6,
        img: "../images/twoinchhose.JPG",
        name: "Two Inch Discharge Hose",
        link: '/catalog/twoinchhose',
    },
]

export const heavyequipmentPhotos = [
    {
        id: 1,
        img: "../images/wheelloader.JPG",
        name: "Wheel Loader",
        link: '/catalog/wheelloader',
    },
    {
        id: 2,
        img: "../images/trackloader.jpeg",
        name: "Track Loader",
        link: '/catalog/trackloader',
    },
    {
        id: 3,
        img: "../images/miniex.JPG",
        name: "Mini Excavataur",
        link: '/catalog/miniexcavataur',
    },
    {
        id: 4,
        img: "../images/miniskid.JPG",
        name: "Mini Skid-Steer",
        link: '/catalog/miniskidsteer',
    },
]

export const fansPhotos = [
    {
        id: 1,
        img: "../images/carpetfan.JPG",
        name: "Carpet Dryer Fan",
        link: '/catalog/carpetfan',
    },
    {
        id: 2,
        img: "../images/drumfan.JPG",
        name: "Drum Fan",
        link: '/catalog/drumfan',
    },
    {
        id: 3,
        img: "../images/exhaustfan.JPG",
        name: "Exhaust Fan",
        link: '/catalog/exhaustfan',
    },
]

export const movingPhotos = [
    {
        id: 1,
        img: "../images/extralargebox.jpeg",
        name: "Extra Large Box",
        link: '/catalog/extralargebox',
    },
    {
        id: 2,
        img: "../images/largebox.jpeg",
        name: "Large Box",
        link: '/catalog/largebox',
    },
    {
        id: 3,
        img: "../images/mediumbox.jpeg",
        name: "Medium Box",
        link: '/catalog/mediumbox',
    },
    {
        id: 4,
        img: "../images/smallbox.jpeg",
        name: "Small Box",
        link: '/catalog/smallbox',
    },
    {
        id: 5,
        img: "../images/grandwardrobe.jpeg",
        name: "Grand Wardrobe Box",
        link: '/catalog/grandwardrobebox',
    },
    {
        id: 6,
        img: "../images/shortwardrobe.jpeg",
        name: "Shorty Wardrobe Box",
        link: '/catalog/shortywardrobebox',
    },
    {
        id: 7,
        img: "../images/bubblewrap.jpeg",
        name: "Bubble Wrap",
        link: '/catalog/bubblewrap',
    },
    {
        id: 8,
        img: "../images/wrappingpaper.jpeg",
        name: "Wrapping Paper",
        link: '/catalog/wrappingpaper',
    },
]

export const cementPhotos = [
    {
        id: 1,
        img: "../images/cutoffsaw.JPG",
        name: "Handheld Cutoff Saw",
        link: '/catalog/cutoffsaw',
    },
    {
        id: 2,
        img: "../images/buggy.JPG",
        name: "Concrete Buggy",
        link: '/catalog/concretebuggy',
    },
    {
        id: 3,
        img: "../images/compactor.JPG",
        name: "Compactor",
        link: '/catalog/compactor',
    },
    {
        id: 4,
        img: "../images/jackhammer.JPG",
        name: "Jack Hammer",
        link: '/catalog/jackhammer',
    },
    {
        id: 5,
        img: "../images/cementmixer.JPG",
        name: "Cement Mixer",
        link: '/catalog/cementmixer',
    },
    {
        id: 6,
        img: "../images/hammerdrill.JPG",
        name: "Hammer Drill",
        link: '/catalog/hammerdrill',
    },
    {
        id: 7,
        img: "../images/bullfloat.JPG",
        name: "Bull Float",
        link: '/catalog/bullfloat',
    },
    {
        id: 8,
        img: "../images/walksaw.JPG",
        name: "Walk Behind Saw",
        link: '/catalog/walkbehindsaw',
    },
]

export const sawsPhotos = [
    {
        id: 1,
        img: "../images/cutoffsaw.JPG",
        name: "Handheld Cutoff Saw",
        link: '/catalog/cutoffsaw',
    },
    {
        id: 2,
        img: "../images/tilesaw.JPG",
        name: "Tile Saw",
        link: '/catalog/tilesaw',
    },
    {
        id: 3,
        img: "../images/walksaw.JPG",
        name: "Walk Behind Saw",
        link: '/catalog/walkbehindsaw',
    },
    {
        id: 4,
        img: "../images/sawzall.JPG",
        name: "Sawzall",
        link: '/catalog/sawzall',
    },
    {
        id: 5,
        img: "../images/sawblades.JPG",
        name: "Saw Blades",
        link: '/catalog/sawblades',
    },
]

export const augerPhotos = [
    {
        id: 1,
        img: "../images/twoman.JPG",
        name: "2-Man Hydraulic Auger",
        link: '/catalog/hydraulicauger',
    },
    {
        id: 2,
        img: "../images/augerbits.JPG",
        name: "Auger Bits",
        link: '/catalog/augerbits',
    },
]

export const compressorsPhotos = [
    {
        id: 1,
        img: "../images/twocompressor.JPG",
        name: "Tow Behind Compressor",
        link: '/catalog/towbehindcompressor',
    },
    {
        id: 2,
        img: "../images/mediumcompressor.JPG",
        name: "Medium Compressors",
        link: '/catalog/mediumcompressors',
    },
    {
        id: 3,
        img: "../images/smallcompressor.JPG",
        name: "Small Compressors",
        link: '/catalog/smallcompressors',
    },
]

export const generatorsPhotos = [
    {
        id: 1,
        img: "../images/largegenerator.JPG",
        name: "Large Generators",
        link: '/catalog/largegenerators',
    },
    {
        id: 2,
        img: "../images/smallgenerator.JPG",
        name: "Small Generators",
        link: '/catalog/smallgenerators',
    },
]

export const laddersandscaffoldingPhotos = [
    {
        id: 1,
        img: "../images/aframe.JPG",
        name: "A Frame Ladders",
        link: '/catalog/aframeladder',
    },
    {
        id: 2,
        img: "../images/extensionladder.JPG",
        name: "Extension Ladders",
        link: '/catalog/extensionladder',
    },
    {
        id: 3,
        img: "../images/indoorscaffolding.webp",
        name: "Indoor Scaffolding",
        link: '/catalog/indoorscaffolding',
    },
    {
        id: 4,
        img: "../images/outdoorscaffolding.jpeg",
        name: "Outdoor Scaffolding",
        link: '/catalog/outdoorscaffolding',
    },
]

export const lawnandgardenPhotos = [
    {
        id: 1,
        img: "../images/sodcutter.JPG",
        name: "Sod Cutter",
        link: '/catalog/sodcutter',
    },
    {
        id: 2,
        img: "../images/logsplitter.JPG",
        name: "Log Splitter",
        link: '/catalog/logsplitter',
    },
    {
        id: 3,
        img: "../images/thatcher.JPG",
        name: "Thatcher",
        link: '/catalog/thatcher',
    },
    {
        id: 4,
        img: "../images/areator.JPG",
        name: "Areator",
        link: '/catalog/areator',
    },
    {
        id: 5,
        img: "../images/edger.JPG",
        name: "Edger",
        link: '/catalog/edger',
    },
    {
        id: 6,
        img: "../images/lawnroller.JPG",
        name: "Lawn Roller",
        link: '/catalog/lawnroller',
    },
    {
        id: 7,
        img: "../images/walkblower.JPG",
        name: "Walk Behind Blower",
        link: '/catalog/walkbehindblower',
    },
    {
        id: 8,
        img: "../images/backpackblower.webp",
        name: "Backpack Blower",
        link: '/catalog/backpackblower',
    },
]

export const miscPhotos = [
    {
        id: 1,
        img: "../images/dolly.webp",
        name: "Appliance Dolly",
        link: '/catalog/appliancedolly',
    },
    {
        id: 2,
        img: "../images/drywalljack.webp",
        name: "Drywall Jack",
        link: '/catalog/drywalljack',
    },
    {
        id: 3,
        img: "../images/extensioncord.JPG",
        name: "Extension Cord",
        link: '/catalog/extensioncord',
    },
    {
        id: 4,
        img: "../images/albrake.webp",
        name: "Aluminum Brake",
        link: '/catalog/alumunimbrake',
    },
    {
        id: 5,
        img: "../images/metaldetector.JPG",
        name: "Metal Detector",
        link: '/catalog/metaldetector',
    },
    {
        id: 6,
        img: "../images/nailer.webp",
        name: "Nailer",
        link: '/catalog/nailer',
    },
]

export const tablesandchairsPhotos = [
    {
        id: 1,
        img: "../images/chair.webp",
        name: "Black Plastic Folding Chairs",
        link: '/catalog/foldingchairs',
    },
    {
        id: 2,
        img: "../images/8foottable.webp",
        name: "8 Foot Banquet Tables",
        link: '/catalog/8foottables',
    },
    {
        id: 3,
        img: "../images/6foottable.webp",
        name: "6 Foot Banquet Tables",
        link: '/catalog/6foottables',
    },
    {
        id: 4,
        img: "../images/5footround.webp",
        name: "5 Foot Round Tables",
        link: '/catalog/5foottables',
    },
]

export const indoorcarePhotos = [
    {
        id: 1,
        img: "../images/carpetcleaner.JPG",
        name: "Carpet Cleaner",
        link: '/catalog/carpetcleaner',
    },
    {
        id: 2,
        img: "../images/dehumidifier.JPG",
        name: "Dehumidifier",
        link: '/catalog/dehumidifier',
    },
    {
        id: 3,
        img: "../images/polisher.JPG",
        name: "Floor Polisher",
        link: '/catalog/floorpolisher',
    },
    {
        id: 4,
        img: "../images/wallpapersteamer.JPG",
        name: "Wallpaper Steamer",
        link: '/catalog/wallpapersteamer',
    },
    {
        id: 5,
        img: "../images/kneekicker.JPG",
        name: "Knee Kicker",
        link: '/catalog/kneekicker',
    },
    {
        id: 6,
        img: "../images/carpetfan.JPG",
        name: "Carpet Dryer Fan",
        link: '/catalog/carpetfan',
    },
]